<template>

  <header v-if="company" class="bx-header  _has-text-centered" :style="backgroundStyle">
      <a v-if="company" v-bind:href="(company.website) ? `http://${company.website}` : ''" target="_blank"><img class="" :src="company.logoUrl"></a>
  </header>

</template>

<script>

export default {
  name: 'header-bar',
  components: {},
  props: ['dateDeadline', 'reopening', 'reopenedSuccess', 'reopenVisible', 'dateSubmitted', 'step', 'stepReached'],
  data () {
    return {
    }
  },
  methods: {
    adjustQuote () {
      this.$emit('adjustQuote')
    }
  },
  computed: {
    company () {
      return this.$store.state.data.company
    },
    backgroundStyle () {
      return `background-image: url(${this.company.logoUrl});
      background-size: cover;
      background-position: 50% 20%;`
    }
  }
}
</script>
